import React, { SVGProps } from 'react';

export function TapIcon({
  color = '#00A47C',
  height = 19,
  strokeWidth = '1.5',
  width = 13,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 13 19' fill='none' {...props}>
      <path
        d='M5.16407 1.759V0M7.50707 2.344L8.67807 1.172M2.82107 2.344L1.65007 1.172M8.09307 4.101H9.85007M2.23607 4.101H0.478073M3.99307 17.573L0.986073 13.565C0.81479 13.3343 0.732151 13.0496 0.753227 12.7631C0.774304 12.4765 0.897691 12.207 1.10089 12.0038C1.30408 11.8006 1.57355 11.6772 1.86013 11.6562C2.14672 11.6351 2.43134 11.7177 2.66207 11.889L3.99007 12.887V5.275C3.99007 4.96443 4.11345 4.66658 4.33305 4.44698C4.55266 4.22737 4.8505 4.104 5.16107 4.104C5.47164 4.104 5.76949 4.22737 5.9891 4.44698C6.2087 4.66658 6.33207 4.96443 6.33207 5.275V9.961L9.59207 10.685C10.1482 10.8086 10.6403 11.1306 10.9762 11.5907C11.3121 12.0509 11.4688 12.6176 11.4171 13.185L11.0181 17.575L3.99307 17.573Z'
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
